module.exports = __webpack_public_path__ + "img/mural-bg.4666560f.jpg";